import {
  Autocomplete,
  Box,
  Divider,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useCommonStyles } from "../../utils";

const CommonAutoComplete = ({
  label,
  size,
  value,
  options,
  placeholder,
  onChange,
  disabled,
  CloseIcondisplay,
  py,
  paddingRight,
  width,
  fontFamily,
  fontWeight,
  fontSize,
  color,
  marginBottom,
  clearIcon,
  onClear,
  loadData,
  searchValue,
  loadName,
  valid,
  labelColor,
  sx,
  getOptionLabel,
  optionsMargin,
  isReadOnly,
  handleSearch,
  blurOnSelect,
  freeSolo
}) => {
  const { classes } = useCommonStyles();

  return (
    <div>
      {label && (
        <Box display={"flex"} gap={'2px'}>
          <InputLabel
            className={classes.label}
            sx={{
              fontWeight: fontWeight ? fontWeight : "500",
              fontSize: fontSize ? fontSize : "14px",
              fontFamily: "Satoshi-Medium",
              color: labelColor || "#2E2E30",
              marginBottom: marginBottom || "8px",
              textTransform: "capitalize",
            }}
          >
            {label}
          </InputLabel>
          {valid && (
            <Typography height={'5px'} color="#EF627A" component={"caption"} variant={"body2"}>
              *
            </Typography>
          )}
        </Box>
      )}
      <Autocomplete
        className={classes.field}
        size={size || "small"}
        value={value}
        options={options}
        disabled={disabled}
        blurOnSelect={blurOnSelect}
        getOptionLabel={getOptionLabel ? getOptionLabel : (option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        // isOptionEqualToValue={(option, value) => !!value && option.id === value.id}
        onChange={onChange}
        onClear={onClear}
        sx={{
          "&.MuiAutocomplete-root": {
            "& .MuiOutlinedInput-root": {
              backgroundColor: '#FFF',
              width: width,
              py: py || "7.5px",
            },
            "& .MuiAutocomplete-clearIndicator": {
              display: CloseIcondisplay,
            },
            "& .MuiAutocomplete-inputRoot": {
              paddingRight: paddingRight,
            },
            "&.MuiAutocomplete-root .MuiAutocomplete-clearIndicator": {
              display: clearIcon ? "" : "none"
            }
          },
          ...sx,
        }}
        ListboxProps={{
          style: {
            maxHeight: "180px",
            border: "1px solid white",
          },
          onScroll: (event) => {
            event.stopPropagation();
            const listboxNode = event.currentTarget;
            const savedScrollTop = listboxNode.scrollTop;
            const diff = Math.round(
              listboxNode.scrollHeight - savedScrollTop
            );
            if (diff <= listboxNode.clientHeight + 1) {
              const returnScrollTop = () => {
                setTimeout(() => {
                  listboxNode.scrollTop = savedScrollTop;
                }, 200);
              };
              if (loadData) {

                loadData(0, searchValue, loadName && loadName);
                returnScrollTop();
              }
            }
          },
        }}
        renderInput={(params) => (
          <TextField {...params} placeholder={placeholder} inputProps={{ ...params.inputProps, readOnly: isReadOnly || false }} onChange={handleSearch} />
        )}
        clearIcon={clearIcon}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          const label = getOptionLabel ? getOptionLabel(option) : option.name;
          return (
            <li
              key={key}
              {...optionProps}
              className={classes.option}
              options={options}
            >
              <Box sx={{ mx: optionsMargin || 1, pt: 1, }}>
                <Typography>
                  {label}
                </Typography>
                <Divider sx={{ color: "#D0D0D0", mt: 1}} />
              </Box>
            </li>
          );
        }}
      />
    </div>
  );
};

export default CommonAutoComplete;
